import * as React from 'react';

import ValueCardWidget from '@/pages/CustomDashboard/Widgets/ValueCardWidget';

const registry = {
    value_card: ValueCardWidget
};

export function Widget({ widget }) {
    const Component = registry[widget.type] || (() => <div>Unknown widget</div>);

    return (
        <div className="tw-w-full tw-h-full tw-p-2">
            <Component widget={widget} />
        </div>
    );
}
